<template>
  <section>
    <qx-search-box
      class="searchBox"
      :searchBoxData="searchBoxData"
      @sub="sub"
      title="筛选"
      permpisionsQuery=""
    >
    </qx-search-box>
    <TableBox ref="tableBox" />
  </section>
</template>
<script>
import TableBox from './tableBox';
import {
  getEnumList,
} from 'api';
import {
  getAddressOptions,
} from '@qx/utils';
export default {
  components: {
    TableBox,
  },
  data () {
    return {
      searchBoxData: {
        businessNumberOptions: [],
        orgIdOptions: [],
        form: [
          {
            label: '订单号',
            value: 'orderId',
            type: 'input',
            placeholder: '请输入订单号',
          },
          {
            label: '回单时间',
            value: 'Time',
            type: 'date',
            placeholder: '请输入回单时间',
            attr: {
              type: 'daterange',
            },
          },
          {
            label: '到期时间',
            value: 'finalTime',
            type: 'date',
            placeholder: '请输入到期时间',
            attr: {
              type: 'daterange',
            },
          },
          {
            label: '业务类型',
            value: 'businessNumber',
            type: 'select',
            placeholder: '请选择业务类型',
            default: '-1',
          },
          { // 始发地
            label: '始发地',
            value: 'sourceRegion',
            type: 'cascader',
            default: [],
            options: getAddressOptions(),
          },
          { // 目的地
            label: '目的地',
            value: 'desRegion',
            type: 'cascader',
            default: [],
            options: getAddressOptions(),
          },
        ],
      },
    };
  },
  methods: {
    sub (searchBoxData) {
      if (searchBoxData.Time && searchBoxData.Time.length) {
        searchBoxData.startTime = searchBoxData.Time[0];
        searchBoxData.endTime = searchBoxData.Time[1];
      }
      delete searchBoxData.Time;
      if (searchBoxData.finalTime && searchBoxData.finalTime.length) {
        searchBoxData.finalStartTime = searchBoxData.finalTime[0];
        searchBoxData.finalEndTime = searchBoxData.finalTime[1];
      }
      delete searchBoxData.finalTime;
      searchBoxData.sourceRegion = searchBoxData.sourceRegion[1];
      searchBoxData.desRegion = searchBoxData.desRegion[1];
      this.$refs.tableBox.saveSearchBoxData({
        userId: this.$route.query.id,
        ...searchBoxData,
      });
    },
  },
  async created () {
    const enumsList = await getEnumList({
      codeType: 'GET_TYPE',
    });
    this.searchBoxData.businessNumberOptions = [
      {
        label: '全部',
        value: '-1',
      },
      ...enumsList[0],
    ];
  },
};
</script>
<style lang="scss" scoped>
</style>
